// // src/pages/DocumentsNew.jsx
// import React, { useEffect, useState } from "react";
// import Default from "../../components/layouts/default";
// import Documents_files_new from "./Documents_files_new";
// import { useDispatch, useSelector } from "react-redux";
// import { setLoading } from "../../feature/loading.slice";
// import { setMessage } from "../../feature/message.slice";
// import messages from "../../utils/meesage";
// import FilesService from "../../services/files.service";
// import { setClient } from "../../feature/client.slice";
// import { useNavigate } from "react-router-dom";

// const DocumentsNew = () => {
//   // Local state for API data and filters
//   const [data, setData] = useState({ files: [], folders: [] });
//   const [dataLoad, setDataLoad] = useState(true);
//   const [searchKeyword, setSearchKeyword] = useState("");
//   const [selectedClient, setSelectedClient] = useState(null);
//   const [folderPath, setFolderPath] = useState([]); 
//   const [clientPath, setClientPath] = useState([]); 
//   const [filterParams, setFilterParams] = useState({
//     folder_id: null,
//     client_id: null,
//     search: "",
//     sortBy: "created_at",
//     sortDirection: "desc",
//   });
//   const navigate = useNavigate();

//   const dispatch = useDispatch();



//   useEffect(() => {
//     const pathParts = window.location.pathname.split("/").filter(Boolean);
//     const newDocIndex = pathParts.indexOf("NewDocument");
  
//     if (newDocIndex !== -1 && pathParts.length > newDocIndex + 1) {
//       const clientId = pathParts[newDocIndex + 1];
//       const folderIds = pathParts.slice(newDocIndex + 2);
  
      
//       // Set client path and filter
//       if (clientId && clientId !== "all") {
//         setClientPath([{ id: clientId }]);
//         setSelectedClient(clientId); // update UI dropdown
//         setFilterParams((prev) => ({
//           ...prev,
//           client_id: clientId,
//         }));
//       }
  
//       // Set folder path and last folder_id
//       if (folderIds.length > 0) {
//         const folderPathData = folderIds.map((fid) => ({ id: fid, name: "" }));
//         setFolderPath(folderPathData);
//         setFilterParams((prev) => ({
//           ...prev,
//           folder_id: folderIds[folderIds.length - 1],
//         }));
//       }
//     }
//   }, []);
  

  
//   useEffect(() => {
//     // Build URL segments starting with "/NewDocument"
//     let url = "/NewDocument";
//     if (clientPath && clientPath.length > 0) {
//       url += `/${clientPath[0].id}`;
//     } else if (filterParams.client_id) {
//       url += `/${filterParams.client_id}`;
//     }
//     if (folderPath.length > 0) {
//       const folderIds = folderPath.map((folder) => folder.id).join("/");
//       url += `/${folderIds}`;
//     }
//     // Update the browser URL (using replace so as not to pollute history)
//     navigate(url, { replace: true });
//     // Also update filterParams.folder_id to the last folder's id (or null)
//     setFilterParams((prev) => ({
//       ...prev,
//       folder_id: folderPath.length > 0 ? folderPath[folderPath.length - 1].id : null,
    
//     }));
//   }, [folderPath, clientPath, navigate]);


//   const clientDetails = useSelector((state) => state.client.client);



 
//   const getFiles = async (folderId = null, clientId = null, search = "") => {
//     setDataLoad(true);
//     dispatch(setMessage(messages.loading));
//     dispatch(setLoading(true));
//     try {
//       const params = {
//         folder_id: folderId, // folder filter
//         client_id: clientId, // client filter
//         search: search, // search keyword filter
//         sortBy: "created_at",
//         sortDirection: "desc",
//       };
//       const response = await FilesService.getNewFile(filterParams);
//       setData(response);
//       setDataLoad(false);
//        dispatch(setClient(response.clientDetails));
//       dispatch(setLoading(false));
//     } catch (err) {
//       console.error(err);
//       dispatch(setLoading(false));
//       dispatch(setMessage(err.message || "Error fetching files"));
//       setDataLoad(false);
//     }
//   };

//   // Fetch files on initial mount (no filters applied)
//   useEffect(() => {
//     getFiles();
//   }, [filterParams]);

//   // Handle search input changes
//   const handleSearchChange = (e) => {
//     const keyword = e.target.value;
//     setSearchKeyword(keyword);

//     setFilterParams((prev) => ({ ...prev, search: keyword }));
//     // Call getFiles with the current client filter and search keyword
//     // getFiles(null, selectedClient, keyword);
//   };

//   // Handle client dropdown change
//   const handleClientChange = (e) => {
//     const value = e.target.value;
//     const clientId = value === "all" ? null : value;
//     setSelectedClient(clientId);
//     setFilterParams((prev) => ({ ...prev, client_id: clientId }));
//     // Fetch files with the new client filter and current search keyword
//     // getFiles(null, clientId, searchKeyword);
//   };


//   const handleFolderClick = (folder) => {

//     setFilterParams((prev) => ({
//       ...prev,
//       folder_id: folder.id,
//     }));

//     // Append folder details to folderPath
//     setFolderPath((prev) => [...prev, { id: folder.id, name: folder.folder_name }]);
//     // Append client details from the folder if available
//     setClientPath((prev) => [...prev, { id: folder.client_id, name: folder.client_name }]);

  
//     // Fetch files for the clicked folder
//     // getFiles();
//   };

//   return (
//     // <Default pageTitle="Documents">
//     <div className="documents card w-100">
//       <div className="card-body">
//         {/* Filter header: Client dropdown and Search input */}
//         <div className="d-flex flex-row justify-content-between align-items-center mb-3">
//           <div className="company-filter">
//             <select
//               className="form-select form-select-sm"
//               onChange={handleClientChange}
//               value={selectedClient || ""}
//             >
//               <option value="" disabled>
//                 By Corporation
//               </option>
//               <option value="all">All</option>
//               {clientDetails &&
//                 clientDetails.map((client) => (
//                   <option key={client.id} value={client.id}>
//                     {client.name}
//                   </option>
//                 ))}
//             </select>
//           </div>
//           <div className="ms-2" style={{ flexGrow: 1 }}>
//             <input
//               type="search"
//               placeholder="Search"
//               className="form-control form-control-sm"
//               value={searchKeyword}
//               onChange={handleSearchChange}
//             />
//           </div>
//         </div>
  
    
  
//         {/* Render Files & Folders */}
//         {dataLoad ? (
//           <div>Loading...</div>
//         ) : (
//           <Documents_files_new
//             responseData={data}
//             getFiles={getFiles}
//             onFolderClick={handleFolderClick}
//           />
//         )}
//       </div>
//     </div>
//     // </Default>
//   );
  
// };

// export default DocumentsNew;


import React, { useEffect, useState } from "react";
import Default from "../../components/layouts/default";
import Documents_files_new from "./Documents_files_new";
import { useDispatch, useSelector } from "react-redux";
import { setLoading } from "../../feature/loading.slice";
import { setMessage } from "../../feature/message.slice";
import messages from "../../utils/meesage";
import FilesService from "../../services/files.service";
import { setClient } from "../../feature/client.slice";
import { useNavigate } from "react-router-dom";
import Document_file_Upload from "./Document_file_Upload";
import { Modal } from "react-bootstrap";
import { resetActiveClient, setActiveClient } from "../../feature/folderPath.slice";

const DocumentsNew = () => {
  const [data, setData] = useState({ files: [], folders: [] });
  const [dataLoad, setDataLoad] = useState(true);
  const [searchKeyword, setSearchKeyword] = useState("");
  const [selectedClient, setSelectedClient] = useState(null);
  // console.log("selectedClient",selectedClient)
  const [folderPath, setFolderPath] = useState([]);
  const [clientPath, setClientPath] = useState([]);
  const [breadcrumbsLoaded, setBreadcrumbsLoaded] = useState(false);
  const [filterParams, setFilterParams] = useState({
    folder_id: null,
    client_id: null,
    search: "",
    sortBy: "created_at",
    sortDirection: "desc",
  });
  const currentFolderId = folderPath.length > 0 ? folderPath[folderPath.length - 1].id : null;

  const [showUploadFile, setUploadFile] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const clientDetails = useSelector((state) => state.client.client);

  useEffect(() => {
    const pathParts = window.location.pathname.split("/").filter(Boolean);
    const newDocIndex = pathParts.indexOf("NewDocument");

    if (newDocIndex !== -1 && pathParts.length > newDocIndex + 1) {
      const clientId = pathParts[newDocIndex + 1];
      const folderIds = pathParts.slice(newDocIndex + 2);

      if (clientId && clientId !== "all") {
        setClientPath([{ id: clientId, name: "" }]);
        setSelectedClient(clientId);
        setFilterParams((prev) => ({
          ...prev,
          client_id: clientId,
        }));
      }

      if (folderIds.length > 0) {
        const folderPathData = folderIds.map((fid) => ({ id: fid, name: "" }));
        setFolderPath(folderPathData);
        setFilterParams((prev) => ({
          ...prev,
          folder_id: folderIds[folderIds.length - 1],
        }));
      }
    }
  }, []);

  useEffect(() => {
    let url = "/NewDocument";
    if (clientPath && clientPath.length > 0) {
      url += `/${clientPath[0].id}`;
    } else if (filterParams.client_id) {
      url += `/${filterParams.client_id}`;
    }
    if (folderPath.length > 0) {
      const folderIds = folderPath.map((folder) => folder.id).join("/");
      url += `/${folderIds}`;
    }
    navigate(url, { replace: true });

    setFilterParams((prev) => ({
      ...prev,
      folder_id: folderPath.length > 0 ? folderPath[folderPath.length - 1].id : null,
    }));
  }, [folderPath, clientPath, navigate, filterParams.client_id]);



  const getFiles = async () => {
    setDataLoad(true);
    dispatch(setMessage(messages.loading));
    dispatch(setLoading(true));
  
    try {
      const response = await FilesService.getNewFile(filterParams);
      setData(response);
      dispatch(setClient(response.clientDetails));
  
      // ✅ Set folderPath once on first load using breadcrumbs
      if (!breadcrumbsLoaded && response.breadcrumbs && response.breadcrumbs.length > 0) {
        const breadcrumbFolders = response.breadcrumbs.map((b) => ({
          id: b.id,
          name: b.name,
        }));
        setFolderPath(breadcrumbFolders);
        setBreadcrumbsLoaded(true);
      }
  
      // ✅ Set clientPath if not already named (find clientDetails anywhere in breadcrumbs)
      if (
        response.breadcrumbs &&
        response.breadcrumbs.length > 0 &&
        (!clientPath.length || !clientPath[0].name)
      ) {
        const breadcrumbWithClient = response.breadcrumbs.find(
          (b) => b.clientDetails && b.clientDetails.name
        );
  
        if (breadcrumbWithClient) {
          setClientPath([
            {
              id: breadcrumbWithClient.client_id,
              name: breadcrumbWithClient.clientDetails.name,
            },
          ]);
          setSelectedClient(breadcrumbWithClient.client_id);
        }
      }
  
      setDataLoad(false);
      dispatch(setLoading(false));
    } catch (err) {
      console.error(err);
      dispatch(setLoading(false));
      dispatch(setMessage(err.message || "Error fetching files"));
      setDataLoad(false);
    }
  };
  
  const uploadFilehandleShow = () => setUploadFile(true);

  useEffect(() => {
    getFiles();
  }, [filterParams]);

  const handleSearchChange = (e) => {
    const keyword = e.target.value;
    setSearchKeyword(keyword);
    setFilterParams((prev) => ({ ...prev, search: keyword }));
  };

  const handleClientChange = (e) => {
    const value = e.target.value;
    const clientId = value === "all" ? null : value;
    setSelectedClient(clientId);
    setFolderPath([]);
    setClientPath(clientId ? [{ id: clientId, name: getClientName(clientId) }] : []);
    setFilterParams((prev) => ({ ...prev, client_id: clientId, folder_id: null }));
  };

  const getClientName = (clientId) => {
    if (!clientDetails) return "";
    const client = clientDetails.find((c) => c.id == clientId);
    return client ? client.name : "";
  };

  const handleFolderClick = (folder) => {
    setFolderPath((prev) => [...prev, { id: folder.id, name: folder.folder_name }]);
    setClientPath((prev) => {
      if (prev.length > 0) return prev;
      if (folder.client_id) return [{ id: folder.client_id, name: folder.client_name }];
      return prev;
    });
    dispatch(setActiveClient({ id: folder.client_id, name: folder.client_name }));
  };

  const handleBreadcrumbClick = (index) => {
    if (index === 0) {
      // Home clicked: reset all
      setFolderPath([]);
      setClientPath([]);
      setSelectedClient(null);
      dispatch(resetActiveClient());
      setFilterParams((prev) => ({
        ...prev,
        client_id: null,
        folder_id: null,
        search: "",
      }));
      setSearchKeyword("");
    } else if (index === 1) {
      // ✅ Client breadcrumb clicked
      const clientId = clientPath[0]?.id || null;
      setFolderPath([]);
      setFilterParams((prev) => ({
        ...prev,
        client_id: clientId,
        folder_id: null,
      }));
    } else {
      // Folder breadcrumb clicked
      const newFolderPath = folderPath.slice(0, index - 1);
      setFolderPath(newFolderPath);
    }
  };
  const uploadFilehandleClose = () => setUploadFile(false);

  return (
    <Default pageTitle="Documents">
      <div className="documents card w-100">
        <div className="card-body">
   {/* Top Header: Breadcrumbs + Filters in the same line */}
<div className="d-flex justify-content-between align-items-center flex-wrap mb-3">
  {/* Breadcrumbs */}
  <nav aria-label="breadcrumb" className="mb-0">
    <ol className="breadcrumb mb-0">
      <li
        className="breadcrumb-item"
        style={{ cursor: "pointer" }}
        onClick={() => handleBreadcrumbClick(0)}
      >
        Home
      </li>
      {clientPath.length > 0 && (
        <li
          className="breadcrumb-item"
          style={{ cursor: "pointer" }}
          onClick={() => handleBreadcrumbClick(1)}
        >
          {clientPath[0].name}
        </li>
      )}
      {folderPath.map((folder, index) => (
        <li
          key={folder.id}
          className="breadcrumb-item"
          style={{ cursor: "pointer" }}
          onClick={() => handleBreadcrumbClick(index + 2)}
        >
          {folder.name}
        </li>
      ))}
    </ol>
  </nav>

  {/* Filters aligned to the right */}
  <div className="d-flex align-items-center gap-2 flex-wrap">
    <select
      className="form-select form-select-sm"
      style={{ width: "200px" }}
      onChange={handleClientChange}
      value={selectedClient || ""}
    >
      <option value="" disabled>
        By Corporation
      </option>
      <option value="all">All</option>
      {clientDetails &&
        clientDetails.map((client) => (
          <option key={client.id} value={client.id}>
            {client.name}
          </option>
        ))}
    </select>

    <input
      type="search"
      placeholder="Search"
      className="form-control form-control-sm"
      style={{ width: "250px" }}
      value={searchKeyword}
      onChange={handleSearchChange}
    />

    <button
      type="button"
      className="btn btn-sm btn-primary"
      onClick={uploadFilehandleShow}
    >
      Upload File
    </button>
  </div>
</div>


          {/* Data Display */}
          {dataLoad ? (
  <div>Loading...</div>
) : data.files.length === 0 && data.folders.length === 0 ? (
  <div className="text-center text-muted py-5">No files or folders found.</div>
) : (
  <Documents_files_new
    responseData={data}
    getFiles={getFiles}
    onFolderClick={handleFolderClick}
  />
)}
        </div>
      </div>

      <Modal
        className="modal-lg p-0 m-0"
        show={showUploadFile}
        onHide={uploadFilehandleClose}
        animation={true}
      >
        <Modal.Header closeButton>
          <Modal.Title>Upload File(s)</Modal.Title>
        </Modal.Header>
        <Modal.Body className="m-0">
          <Document_file_Upload
            uploadFilehandleClose={uploadFilehandleClose}
            getFiles={getFiles}
            currentFolderId={currentFolderId} 
          />
        </Modal.Body>
      </Modal>
    </Default>
  );
};

export default DocumentsNew;

